
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const getAllSesiones = async ( params = {} ) => {


  const query = `
    query SesionesTerapia(
      $tokenSesion        : String
      $tokenTerapiaEnviada: String
    ) {
      sesionesTerapia(
        tokenSesion: $tokenSesion
        tokenTerapiaEnviada: $tokenTerapiaEnviada
      ) {
        message
        status
        sesionesTerapia {
          id
          token
          fechaSesion
          horaSesion
          estadoSesion
          solicitudTerapia {
            token
            terapia {
            tipoTerapia {
            id
            descripcion}}
          }
          dataFormulario
        }
      }
    }
  `;

  const variables = {
    ...params
  }

  try{

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;
    
    return response

  }catch(error){
    console.error('Error al obtener la sesion', error);
    return null;
  }
}

 const obtenerDataSesionTerapia = async (tokenTerapia) => {

   const query = `
      query ObtainDetailsSesionTerapia($tokenSesion: String!) {
    obtainDetailsSesionTerapia(tokenSesion: $tokenSesion) {
                status
        message
        sesionTerapia {
            id
            fechaCreacion
            ultimoCambio
            token
            fechaSesion
            horaSesion
            estadoSesion
            dataFormulario
            estado
            urlMspPaciente
            urlMspTitular1
            urlMspTitular2
            urlMspTitular3
            solicitudTerapia {
                id
                fechaCreacion
                ultimoCambio
                token
                fechaProgramada
                cantidad
                estadoTerapia
                numeroOrdenAs400
                motivoSolicitud
                resumenClinico
                estado
                contadorDetalles
                alertaIgnorada
                terapia {
                    id
                    fechaCreacion
                    ultimoCambio
                    token
                    nombre
                    codigo
                    estado
                    numMax
                    precio
                    precioJson
                    estadoJson
                }
                consultamedica {
                    id
                    fechaCreacion
                    ultimoCambio
                    token
                    estadoRev
                    comentarioValidacion
                    signature
                    urlConsentimiento
                    estado
                    horainicio
                    semiologia
                    cita {
                        id
                        fechaCreacion
                        ultimoCambio
                        token
                        urlsMspPaciente
                        urlsMspTitular1
                        urlsMspTitular2
                        urlsMspTitular3
                        urlSolImgDer
                        urlSolLabDer
                        estadoCita
                        estado
                        estadoSignosvital
                        fechaCita
                        estadoActual
                        horaCita
                        encuesta
                        derivacion
                        codderivacion
                        fecderivacion
                        segderivacion
                        urlDerivacion
                        urlCodigoDer
                        isInterconsulta
                        estadoRevision
                        fechaIngreso
                        url007Recibido
                        urlSolProcDer
                        urlOtrosDocumentos
                        tipoServicios
                        usuarioCreadorUsername
                        paciente {
                            id
                            fechaCreacion
                            ultimoCambio
                            token
                            numHistoriaClinica
                            tipoCobertura
                            estado
                            persona {
                                id
                                fechaCreacion
                                ultimoCambio
                                token
                                tipoIdentificacion
                                identificacion
                                primerApellido
                                segundoApellido
                                primerNombre
                                segundoNombre
                                fechaNacimiento
                                telefono
                                estadoCivil
                                sexo
                                correo
                                esDiscapacitado
                                tipoEmpresa
                                urlIdentificacion
                                urlCarnet
                                urlCarnetIsspol
                                urlCarnetIssfa
                                estado
                            }
                        }
                        doctor {
                            id
                            fechaCreacion
                            ultimoCambio
                            token
                            numeroregistrosenescyt
                            urlTituloSenescyt
                            urlP12FirmaElectronica
                            urlFirmaSello
                            fechainiciodoctor
                            estado
                            idPersona {
                                id
                                fechaCreacion
                                ultimoCambio
                                token
                                tipoIdentificacion
                                identificacion
                                primerApellido
                                segundoApellido
                                primerNombre
                                segundoNombre
                                fechaNacimiento
                                telefono
                                estadoCivil
                                sexo
                                correo
                                esDiscapacitado
                                tipoEmpresa
                                urlIdentificacion
                                urlCarnet
                                urlCarnetIsspol
                                urlCarnetIssfa
                                estado
                            }
                        }
                    }
                }
            }
        }
    }
}

      `;
    

      const varConsulta = {
        tokenSesion: tokenTerapia,
      }
      try {
        const response = await axios.post(
          rutas.axios + 'api',
          { query, variables: varConsulta }
        );

        if (response.status === 200) {
          if (response.data.data.obtainDetailsSesionTerapia.status === 'Success') {
            if (response.data.data.obtainDetailsSesionTerapia.sesionTerapia) {

              const sesionTerapia = response.data.data.obtainDetailsSesionTerapia.sesionTerapia
              const paciente = sesionTerapia.solicitudTerapia.consultamedica.cita.paciente

              console.log("terapia nombre", sesionTerapia)
            
              const responseData = {
                sesionTerapia : sesionTerapia, paciente: paciente
              }

              return responseData

              
              // this.terapia = {
              //   id: terapia.id,
              //   nombre: terapia.nombre,
              //   codigo: terapia.codigo,
              //   estado: terapia.estado === '1' || terapia.estado === 1 ? true : false,
              //   precioNeto: terapia.precioNeto,
              //   precioJson: this.convertTojson(terapia.precioJson),
              //   estadoJson: this.convertTojson(terapia.estadoJson)

              // }

            } else {
              console.log("No se encontraron terapias");
            }
          } else {
            console.log("Error en la respuesta del servidor");
          }
        }
      } catch (error) {
        console.error("Error fetching terapias:", error);
      }
    }


  const saveDataSesionTerapia = async (tokenTerapia, dataForm) => {

   const query = `
      mutation SaveDataSesionTerapia($dataForm: String!, $tokenSesion: String!) {
    saveDataSesionTerapia(dataForm: $dataForm, tokenSesion: $tokenSesion) {
        message
        status
        sesionActualizada {
            id
            fechaCreacion
            ultimoCambio
            token
            fechaSesion
            horaSesion
            estadoSesion
            dataFormulario
            estado
            urlMspPaciente
            urlMspTitular1
            urlMspTitular2
            urlMspTitular3
        }
    }
}
      `;
    

      const varConsulta = {
        tokenSesion: tokenTerapia,
        dataForm: dataForm
      }
      try {
        const response = await axios.post(
          rutas.axios + 'api',
          { query, variables: varConsulta }
        );

        if (response.status === 200) {
          if (response.data.data.saveDataSesionTerapia.status === 'SUCCESS') {
            if (response.data.data.saveDataSesionTerapia.sesionActualizada) {

              console.log("data terapia actualizad", response)
            
              
              return response.data.data.saveDataSesionTerapia.sesionActualizada


            } else {
              console.log("No se encontraron terapias");
            }
          } else {
            console.log("Error en la respuesta del servidor");
          }
        }
      } catch (error) {
        console.error("Error fetching terapias:", error);
      }
    }


  const updateSesionByToken = async (tokenSesion, fieldsToUpdate) => {

  if(!tokenSesion) return null;

  const query = `
    mutation UpdateSesionByToken(
      $tokenSesion:String!
      $fieldsToUpdate:SesionTerapiaFields
    ) {
      UpdateSesionByToken(
        tokenSesion : $tokenSesion
        fieldsToUpdate : $fieldsToUpdate
      ) {
        message
        status
        sesion {
        id
        token
        urlMspPaciente
        urlMspTitular1
        urlMspTitular2
        urlMspTitular3

        }
      }
    }

  `;

  const variables = {
    tokenSesion : tokenSesion,
    fieldsToUpdate      : { ...fieldsToUpdate }
  }


  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.UpdateSesionByToken;
    if(response2.status !== 'success') return null;

    const data = response2.sesion;
    return data;

  }catch(error){
    console.error('Error al registrar las terapias de la atencion', error);
    return null;
  }
}




const getSesionesByTerapia = async ( tokenTerapiaEnviada ) => {

  if(!tokenTerapiaEnviada) {
    console.error('token de la terapia es requerido');
    return null;
  }

  const response =  await getAllSesiones({ tokenTerapiaEnviada })
  console.log('response ses', response);
  const sesiones = response.data.data.sesionesTerapia.sesionesTerapia


  return sesiones;
}




export const sesionesTerapiaService = {
  getAllSesiones,
  getSesionesByTerapia,
  obtenerDataSesionTerapia,
  saveDataSesionTerapia,
  updateSesionByToken
}